import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';

@Component({
  selector: 'app-modal-query-help',
  templateUrl: './modal-query-help.component.html',
  styleUrls: ['./modal-query-help.component.scss'],
  imports: [MatDialogModule, MatButtonModule, MatIconModule, MatTabsModule],
})
export class ModalQueryHelpComponent {}
